import { createContext } from 'react';

export const PhoneLinesContext = createContext();